import { Box } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import CommonIconButton from "../ui-kit/buttons/icon-button";

interface OverlayProps {
  children: React.ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;
  header?: React.ReactNode;
}

export default function Overlay({
  open,
  setOpen,
  header,
  children,
}: OverlayProps) {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Box
      sx={(t) => ({
        position: "fixed",
        top: 64,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: t.zIndex.drawer + 1,
        transform: open ? "translateX(0)" : "translateX(100%)",
        transition: "transform 0.5s ease-in-out",
        boxShadow: t.shadows[6],
        backgroundColor: t.nawy.colors.semantic.layer.secondary,
        height: `calc(100vh - 64px)`,
      })}
    >
      <Box
        sx={(t) => ({
          display: "flex",
          gap: t.nawy.spacing.sm,
          p: t.nawy.spacing.md,
          borderBottom: `1px solid ${t.nawy.colors.semantic.border.secondary}`,
          backgroundColor: t.nawy.colors.semantic.layer.primary,
        })}
      >
        <CommonIconButton onClick={handleClose} variant="outlined-secondary">
          <ArrowLeft />
        </CommonIconButton>
        {header}
      </Box>
      {children}
    </Box>
  );
}
